import React, { useState } from "react";
import { Button, Form, Container, Row, Col, Table, Alert } from "react-bootstrap";

const ProductTemplate = () => {
  const [productData, setProductData] = useState({
    productName: "",
    cgst: "",
    sgst: "",
    mrp: "",
    mrpWithoutGst: "",
    dp: "",
    dpWithoutGst: "",
    productDescription: "",
    categoryName: "",
    subCategoryName: "",
    descriptiveSubCategoryName: "",
    brandName: "",
    unitName: "",
    productCode: "",
    bv: "",
    pv: "",
    image: null,
  });

  const [productList, setProductList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    setProductData({
      ...productData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductData({ ...productData, image: URL.createObjectURL(file) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic validation
    if (productData.productName && productData.mrp && productData.dp) {
      setProductList([...productList, productData]);
      setShowAlert(true); // Display success message
      setProductData({
        productName: "",
        cgst: "",
        sgst: "",
        mrp: "",
        mrpWithoutGst: "",
        dp: "",
        dpWithoutGst: "",
        productDescription: "",
        categoryName: "",
        subCategoryName: "",
        descriptiveSubCategoryName: "",
        brandName: "",
        unitName: "",
        productCode: "",
        bv: "",
        pv: "",
        image: null,
      });
    } else {
      setShowAlert(false); // Show error message
    }
  };

  const handleDelete = (index) => {
    const updatedList = productList.filter((_, i) => i !== index);
    setProductList(updatedList);
  };

  return (
    <Container className="mt-5">
      <h3 className="text-center mb-4">Create New Product</h3>

      {/* Success/Error Alert */}
      {showAlert !== null && (
        <Alert variant={showAlert ? "success" : "danger"}>
          {showAlert ? "Product added successfully!" : "Please fill out required fields."}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        {/* Category, Subcategory, Descriptive Subcategory */}
        <Row className="mb-4">
          <Col md={4}>
            <Form.Group controlId="formCategoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                name="categoryName"
                value={productData.categoryName}
                onChange={handleChange}
                placeholder="Enter Category Name"
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formSubCategoryName">
              <Form.Label>Sub Category Name</Form.Label>
              <Form.Control
                type="text"
                name="subCategoryName"
                value={productData.subCategoryName}
                onChange={handleChange}
                placeholder="Enter Sub Category Name"
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formDescriptiveSubCategoryName">
              <Form.Label>Descriptive Sub Category</Form.Label>
              <Form.Control
                type="text"
                name="descriptiveSubCategoryName"
                value={productData.descriptiveSubCategoryName}
                onChange={handleChange}
                placeholder="Enter Descriptive Sub Category"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Product Details */}
        <Row className="mb-4">
          <Col md={4}>
            <Form.Group controlId="formBrandName">
              <Form.Label>Brand Name</Form.Label>
              <Form.Control
                type="text"
                name="brandName"
                value={productData.brandName}
                onChange={handleChange}
                placeholder="Enter Brand Name"
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formUnitName">
              <Form.Label>Unit Name</Form.Label>
              <Form.Control
                type="text"
                name="unitName"
                value={productData.unitName}
                onChange={handleChange}
                placeholder="Enter Unit Name"
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formProductName">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                type="text"
                name="productName"
                value={productData.productName}
                onChange={handleChange}
                placeholder="Enter Product Name"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Tax & Pricing */}
        <Row className="mb-4">
          <Col md={4}>
            <Form.Group controlId="formCGST">
              <Form.Label>CGST (%)</Form.Label>
              <Form.Control
                type="number"
                name="cgst"
                value={productData.cgst}
                onChange={handleChange}
                placeholder="Enter CGST"
                step="0.01"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formSGST">
              <Form.Label>SGST (%)</Form.Label>
              <Form.Control
                type="number"
                name="sgst"
                value={productData.sgst}
                onChange={handleChange}
                placeholder="Enter SGST"
                step="0.01"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formMRP">
              <Form.Label>MRP</Form.Label>
              <Form.Control
                type="number"
                name="mrp"
                value={productData.mrp}
                onChange={handleChange}
                placeholder="Enter MRP"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        {/* MRP Without GST and DP */}
        <Row className="mb-4">
          <Col md={6}>
            <Form.Group controlId="formMRPWithoutGST">
              <Form.Label>MRP without GST</Form.Label>
              <Form.Control
                type="number"
                name="mrpWithoutGst"
                value={productData.mrpWithoutGst}
                onChange={handleChange}
                placeholder="Enter MRP Without GST"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formDP">
              <Form.Label>DP</Form.Label>
              <Form.Control
                type="number"
                name="dp"
                value={productData.dp}
                onChange={handleChange}
                placeholder="Enter DP"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* DP Without GST and Description */}
        <Row className="mb-4">
          <Col md={6}>
            <Form.Group controlId="formDPWithoutGST">
              <Form.Label>DP Without GST</Form.Label>
              <Form.Control
                type="number"
                name="dpWithoutGst"
                value={productData.dpWithoutGst}
                onChange={handleChange}
                placeholder="Enter DP Without GST"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formProductDescription">
              <Form.Label>Product Description</Form.Label>
              <Form.Control
                as="textarea"
                name="productDescription"
                value={productData.productDescription}
                onChange={handleChange}
                placeholder="Enter Description"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Image Upload */}
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group controlId="formImage">
              <Form.Label>Product Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleImageChange}
                accept="image/*"
              />
              {productData.image && (
                <div className="mt-3">
                  <h5>Image Preview:</h5>
                  <img
                    src={productData.image}
                    alt="Product"
                    style={{ width: "150px", height: "150px", objectFit: "cover" }}
                  />
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Button variant="primary" type="submit" className="w-100 mt-3">
          Add Product
        </Button>
      </Form>

      {/* Product List Table */}
      <h3 className="text-center mt-5">Product List</h3>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Product Name</th>
            <th>Category</th>
            <th>Brand</th>
            <th>MRP</th>
            <th>MRP (without GST)</th>
            <th>DP</th>
            <th>DP (without GST)</th>
            <th>CGST</th>
            <th>SGST</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {productList.map((product, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{product.productName}</td>
              <td>{product.categoryName}</td>
              <td>{product.brandName}</td>
              <td>{product.mrp}</td>
              <td>{product.mrpWithoutGst}</td>
              <td>{product.dp}</td>
              <td>{product.dpWithoutGst}</td>
              <td>{product.cgst}</td>
              <td>{product.sgst}</td>
              <td>
                {product.image && (
                  <img
                    src={product.image}
                    alt="Product"
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                  />
                )}
              </td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default ProductTemplate;
